import React from 'react';
import {DAY_NAMES} from "../../../constants/Constants";
const LineColors = [
    ["#F8f8f8", "#f3f3f3"],
    ["#efefef", "#eaeaea"]
]
const height= "40px"
export default class OrderWindowCard extends React.Component {
    render() {
        let mainStyle = {
            display: "flex",
            maxHeight: height,
            width: "1010px",
            fontSize: `${this.props.fontSize ?? 10}px`,
            fontWeight: this.props.fontWeight ?? "bold",
            textAlign: "center",
            verticalAlign: "middle",
            lineHeight: height
        }
        let colorColumnEven = {
            background: LineColors[this.props.index % 2][0],
            maxHeight: height
        }

        let colorColumnOdd = {
            background: LineColors[this.props.index % 2][1],
            maxHeight: height
        }

        let marginStyle = {
            verticalAlign: "middle"
        }
        return <div style={mainStyle}>
            <div style={{
                ...colorColumnEven,
                width: "20px"
            }}>
                <img alt={"icon"} src={this.props.icon} style={marginStyle}/>
            </div>
            <div style={{
                ...colorColumnOdd,
                width: "110px"
            }}>
                {this.props.code}
            </div>
            <div style={{
                ...colorColumnEven,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                lineHeight: '1',
                width: "110px"
            }}>
                {this.props.client}
            </div>
            <div style={{
                ...colorColumnOdd,
                width: "110px"
            }}>
                {this.props.from}
            </div>
            <div style={{
                ...colorColumnEven,
                width: "110px"
            }}>
                {this.props.to}
            </div>
            <div style={{
                ...colorColumnOdd,
                width: "110px"
            }}>
                {this.props.cargo}
            </div>
            <div style={{
                ...colorColumnEven,
                width: "55px"
            }}>
                {(Number.isInteger(this.props.day) ? DAY_NAMES[this.props.day] : this.props.day) }
            </div>
            <div style={{
                ...colorColumnOdd,
                width: "55px"
            }}>
                {(Number.isInteger(this.props.year) ? this.props.year + 1 : this.props.year) }
            </div>
            <div style={{
                ...colorColumnEven,
                width: "110px"
            }}>
                {this.props.weight !== "0" ? this.props.weight : "Выполнен"}
            </div>
            <div style={{
                ...colorColumnOdd,
                width: "110px"
            }}>
                {this.props.cost}
            </div>
            <div style={{
                ...colorColumnEven,
                width: "110px"
            }}>
                {this.props.credit}
            </div>
        </div>;
    }
}
